/**
 * External Dependencies
 */
import { get, filter, flatten } from "lodash";

/**
 * Internal dependencies
 */
import getCubeMeta from "./get-cube-meta";

export default (state, cubeName) => {
  let cubes = get(getCubeMeta(state), ["cubes"], []);
  /*
  if (cubeName) {
    let found = filter(cubes, { name: cubeName });
    if (found) {
      const relatedModels = get(
        found,
        ["0", "meta", "related_models", "measures"],
        []
      );
      const matchingCubes = filter(cubes, (cube) => {
        return relatedModels.includes(cube.name);
      });

      cubes = [...found, ...matchingCubes];
    }
  }
    */
  return flatten(cubes.map(({ measures }) => measures));
};
